/**
 * 第一层：通过 URL 后缀判断是否为图片
 * 适用于绝大多数 CDN / OSS 链接（阿里云、七牛等），零延迟
 * @param {string} str
 * @returns {boolean}
 */
export function isImageUrl(str) {
	return /^https?:\/\/.+\.(png|jpg|jpeg|gif|webp|bmp|svg)(\?.*)?$/i.test(str)
}

/** 判断字符串是否长得像 URL */
export function looksLikeUrl(str) {
	return /^https?:\/\//.test(str)
}

/**
 * 第二层（异步兜底）：用 Image 对象实际加载探测
 * 图片加载不受 CORS 限制，可以跨域探测
 * 浏览器底层直接对字节流做图片解码 —— 能解码成功就是图片，否则不是
 * @param {string} url
 * @param {number} timeout 超时毫秒数
 * @returns {Promise<boolean>}
 */
export function probeImageUrl(url, timeout = 5000) {
	return new Promise((resolve) => {
		const img = new Image()
		const timer = setTimeout(() => resolve(false), timeout)
		img.onload = () => {
			clearTimeout(timer)
			resolve(true)
		}
		img.onerror = () => {
			clearTimeout(timer)
			resolve(false)
		}
		img.src = url
	})
}
